import React, { Dispatch } from 'react';
import Translator from '../../../../core/i18n';
import { Log } from 'ng2-logger';
import { Common } from '../../../../core/common';

import { connect } from 'react-redux';
import { IAppState, IAction } from '../../../../models/action/core';
import { FormikProps } from 'formik';
import { SurveyQuestionType } from '../../../../models/enums/SurveyQuestionType';
import Header from './questionTypes/header';
import Choice from './questionTypes/choice';
import Paragraph from './questionTypes/paragraph';
import Matrix from './questionTypes/matrix';
import { IQuestionList } from '../../../../models/components/add-activity-survey-questions';
import { IResponseData } from '../../../../models/components/activity-card-survey';
import { Guid } from 'guid-typescript';
import  OpenEnded  from './questionTypes/openended';

const _logger = Log.create('Card in Survey');
const T = Translator.create();
let _common: Common;

interface ICardProps {
    formik: FormikProps<IResponseData>;
    questionList?: IQuestionList[];
}

class Card extends React.Component<ICardProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    returnQuestions = (question: IQuestionList) => {
        let child;
        if (question) {
            switch (question.questionType) {
                case SurveyQuestionType.Heading:
                    child = (
                        <React.Fragment>
                            <div className="row">
                                <Header formik={this.props.formik} question={question} isCard={true}/>
                            </div>
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.Paragraph:
                    child = (
                        <React.Fragment>
                            <div className="row">
                                <Paragraph formik={this.props.formik} question={question} isCard={true}/>
                            </div>
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.OpenEndedTextArea:
                    child = (
                        <React.Fragment>
                            <div className="row">
                                <OpenEnded key={Guid.create().toString()} formik={this.props.formik} question={question} isCard={true}/>
                            </div>
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.OpenEndedOneLine:
                    child = (
                        <React.Fragment>
                            <div className="row">
                                <OpenEnded key={Guid.create().toString()} formik={this.props.formik} question={question} isCard={true} />
                            </div>
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.Matrix:
                    child = (
                        <React.Fragment>
                            <div className="row">
                                <Matrix key={Guid.create().toString()} formik={this.props.formik} question={question} isCard={true}/>
                            </div>
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.MultipleChoice:
                    child = (
                        <React.Fragment>
                            <div className="row">
                                <Choice key={Guid.create().toString()} formik={this.props.formik} isMulti={true} question={question} isCard={true}/>
                            </div>
                        </React.Fragment>
                    );
                    break;
                case SurveyQuestionType.SingleChoice:
                    child = (
                        <React.Fragment>
                            <div className="row">
                                <Choice key={Guid.create().toString()} formik={this.props.formik} isMulti={false} question={question} isCard={true}/>
                            </div>
                        </React.Fragment>
                    );
                    break;
                default:
                    break;
            }
        }
        return child;
    };

    public render() {
        return (
            <div className="card-question">
                <div className="row">
                    <div className="w-100 mx-2 d-flex flex-column">
                        <div className="survey-progress">
                            <div className="progress">
                                <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{
                                        width:
                                            (this.props.questionList && this.props.questionList.length
                                                ? ((this.props.formik.values.questionIndex + 1) * 100) / this.props.questionList.length
                                                : 0) + '%'
                                    }}
                                    aria-valuemin={0}
                                    aria-valuemax={100}
                                />
                            </div>
                        </div>
                        <span className="survey-counter-text">
                            {T.t('r_survey_question')}{' '}
                            <b>
                                {this.props.questionList && this.props.questionList.length ? this.props.formik.values.questionIndex + 1 : 0}
                                /{this.props.questionList && this.props.questionList.length ? this.props.questionList.length : 0}
                            </b>{' '}
                        </span>
                    </div>
                </div>
                {this.props.questionList && this.props.questionList.length
                    ? this.returnQuestions(this.props.questionList.sort((a, b) => a.displayOrder - b.displayOrder)[this.props.formik.values.questionIndex])
                    : ''}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICardProps): ICardProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: ICardProps = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        userType: state.login.identitiy.userType
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CCard = connect(mapStateToProps, dispatchProps)(Card);

export default CCard;
